// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tA5-","col":"styles_col__3gxrm"};